/* eslint-disable */
import {PlatformNavigationItem} from '@platform/components/navigation';

const nav: PlatformNavigationItem[] = [
    {
        id: 'return',
        title: 'Returns',
        type: 'basic',
        icon: 'mat_outline:recycling',
        link: '/recycling/utility'
    },
    {
        id: 'reports',
        title: 'Reports',
        type: 'group',
        icon: 'mat_outline:content_paste',
        children: [
            {
                id: 'reports.line_item',
                title: 'Line Item Report',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-check',
                link: '/reports/line-item-report',
            },
            {
                id: 'net_suite.export',
                title: 'Net Suite Download',
                type: 'basic',
                icon: 'heroicons_outline:cloud-arrow-down',
                link: '/reports/net-suite-export',
            }
        ]
    }
];

export const defaultNavigation = nav;
export const compactNavigation = nav;
export const futuristicNavigation = nav;
export const horizontalNavigation = nav;
